import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { get } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";

const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL

const Occasion = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [banner, setBanner] = useState([]);
    const [productOccasionData, setProductOccasionData] = useState([]);
    const [subCategoryData, setSubCategoryData] = useState([]);

    const GetProductDetailByIsOccasion = async () => {
        setLoading(true);
        try {
            const response = await get(API_URL.GetProductDetailByIsOccasion);
            if (response.isSuccess === 200) {
                setProductOccasionData(response?.data);
            } else {
                setProductOccasionData([])
            }
        } catch (error) {
            setProductOccasionData([])
        } finally {
            setLoading(false);
        }
    };

    const GetProductDetailById = async () => {
        setLoading(true);
        try {

            let url = `${API_URL?.GetProductSubCategoryByCategoryId}?pProductCategoryId=1032`;

            const response = await get(url);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product => product.isDisplay);
                setSubCategoryData(filteredData);
            }
        } catch (error) {
            setSubCategoryData([]);
        } finally {
            setLoading(false);
        }
    };

    const GetBannerByBannerType = async () => {
        setLoading(true);
        try {
            const response = await get(API_URL.GetBannerByBannerType + `?pBannerTypeName=DiwaliCollection`);
            if (response.isSuccess === 1) {
                setBanner(response?.data[0]);
            } else {
                setBanner([]);
            }
        } catch (error) {
            setBanner([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        GetBannerByBannerType();
        GetProductDetailByIsOccasion();
        GetProductDetailById();
    }, []);

    const onProductBySubCategoryId = (item) => {
        localStorage.setItem('productSubCategoryId', item?.productSubCategoryId);
        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
    };

    if (loading) return <div>loading...</div>;

    return (
        <>
            {productOccasionData?.length > 0 && (
                <section className="shop_occasion_wepper">
                    <div className="hedding">
                        <h2>Shop by Occasion</h2>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            {subCategoryData?.slice(0, 8).map((item, index) => {

                                const imagePath = item?.imgPath ? `${imageUrl}${item?.imgPath}`
                                    : './images/defaultImage.png';

                                return (
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-4" key={index}>
                                        <div className="shop_occasion_img_book_wepper curser-pointer" onClick={() => onProductBySubCategoryId(item)}>
                                            <div className="shop_occasion_img_book">
                                                <div className="overflow-hidden">
                                                    <img
                                                        style={{ cursor: 'pointer' }}
                                                        key={imagePath}
                                                        src={imagePath}
                                                        alt={`Product ${index + 1}`}
                                                    />
                                                </div>
                                            </div>
                                            <p className="underline-hover capitalize">{item?.displayName}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    {/* <SubCategory /> */}
                </section>
            )}
            <section>
                <div className="bg_collection">
                    <div className="desktop_banner">
                        <Link to={banner?.bannerUrl || '/'}>
                            <img src={`${imageUrl}${banner?.bannerImagePath}`} alt="" className="w-100" />
                        </Link>
                    </div>
                    <div className="mobile_banner">
                        <Link to={banner?.bannerUrl || '/'}>
                            <img src={`${imageUrl}${banner?.bannerImageMobile}`} alt="" className="w-100" />
                        </Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Occasion;